import { useFirebaseContext } from '@medely/ui-kit';
import { axios } from 'utils/networkRequests';
import useSnackbar from 'hooks/useSnackbar';
import { StringParam, useQueryParams } from 'use-query-params';
import pick from 'lodash/pick';
import { useRollbar } from '@mp';

const useSignUp = () => {
  const { login } = useFirebaseContext();
  const snackbar = useSnackbar();
  const { notifyRollbar } = useRollbar();
  const [{ utm_source, utm_campaign, signup_assignment_id, signup_job_board_id }] = useQueryParams({
    utm_source: StringParam,
    utm_campaign: StringParam,
    signup_assignment_id: StringParam,
    signup_job_board_id: StringParam,
  });
  return async (values) => {
    // Try to sign up and prevent a login attempt on failure by returning
    try {
      await axios.post(
        '/v3/professional/accounts',
        {
          professional: {
            ...values.professional,
            kinds: [values.professional.kinds],
            signup_assignment_id,
            signup_job_board_id,
          },
          account: { ...values.account, utm_source, utm_campaign },
        },
        {
          withCredentials: true,
        },
      );
    } catch (error) {
      snackbar.error(error);
      return;
    }

    // After successful sign up, attempt to login
    // On failure, notify Rollbar and redirect to login instead of home
    // These two blocks need to be separate because of the
    // Rollbar notification being specific to login issues, not sign up
    try {
      await login?.({
        email: values.account.email,
        password: values.account.password,
      });
    } catch (error) {
      const errorFields = ['name', 'code', 'message'];
      const sanitizedError = pick(error, errorFields);

      notifyRollbar({
        errorLabel: 'Client-side Firebase Error - Pro Not Logged In After Signup',
        args: {
          error: sanitizedError,
        },
      });
      location.replace('/login');
      return;
    }
    location.replace('/');
  };
};

export default useSignUp;
